import { CreateRolePermissionPayload, UpdateRolePermissionsPayload } from '../../models/payload/role';

import { ropoloRequest } from '../axios';

const getPermissions = async () => (await ropoloRequest.identityPermissionsMeList()).data;

const getAllAvailablePermissions = async () => (await ropoloRequest.identityPermissionsList()).data;

const createRolePermission = async (payload: CreateRolePermissionPayload) =>
  ropoloRequest.identityPermissionsCreate(payload);

const updateRolePermission = async (payload: UpdateRolePermissionsPayload) =>
  ropoloRequest.identityPermissionsUpdate(payload);

export { createRolePermission, getAllAvailablePermissions, getPermissions, updateRolePermission };
